export const getPieChartOptions = () => {
  return {
    labels: ["Issued", "Revoked", "Failed", "Expired"],
    colors: ["#808080"],
    chart: {
      width: "50px",
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      formatter: function (value) {
        return parseFloat(value).toFixed(1) + "%";
      },
      style: {
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontWeight: "bold",
        colors: ["#FFFFFF"],
      },
    },
    hover: { mode: null },
    plotOptions: {
      pie: {
        expandOnClick: false,
      },
      donut: {
        expandOnClick: false,
        donut: {
          labels: {
            show: false,
          },
        },
      },
    },
    fill: {
      colors: ["#3366CC", "#DC3912", "#FF9900", "#b9b9b9"],
    },
    tooltip: {
      enabled: true,
      theme: "dark",
      y: {
        formatter: function (value) {
          return parseFloat(value).toFixed(1) + "%";
        },
      },
    },
  };
};

export const getPieChartSeries = (credentialDistribution) => {
  return [
    parseFloat((credentialDistribution?.issued || 0).toFixed(1)),
    parseFloat((credentialDistribution?.revoked || 0).toFixed(1)),
    parseFloat((credentialDistribution?.failed || 0).toFixed(1)),
    parseFloat((credentialDistribution?.expired || 0).toFixed(1)),
  ];
};
